export function getLTV(propertyValue: string, loanAmount: string) {
  if (!propertyValue || !loanAmount) {
    return undefined;
  }

  return Math.ceil((parseInt(loanAmount) / parseInt(propertyValue)) * 100);
}
